import { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

/**
 * Animates the matched descendants of the returned ref with a fade + rise
 * the first time they scroll into view. Attach the returned ref to the
 * section/container element, and pass a selector for the elements to animate.
 */
export function useScrollReveal(selector, options = {}) {
  const containerRef = useRef(null);
  const { y = 40, duration = 0.8, ease = 'power3.out', stagger = 0.12, start = 'top 82%' } = options;

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;
    const targets = container.querySelectorAll(selector);
    if (!targets.length) return;

    gsap.set(targets, { opacity: 0, y });

    const tween = gsap.to(targets, {
      opacity: 1,
      y: 0,
      duration,
      ease,
      stagger,
      scrollTrigger: {
        trigger: container,
        start,
        once: true,
      },
    });

    return () => {
      tween.scrollTrigger?.kill();
      tween.kill();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selector]);

  return containerRef;
}
